"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostedTransactionMockData = exports.getPendingTransactionMockData = void 0;
const uuid_1 = require("uuid");
const luxon_1 = require("luxon");
const accounts_1 = require("companion-app-components/flux/accounts");
const redux_store_1 = __importDefault(require("companion-app-components/utils/redux-store"));
const getPendingTransactionMockData = () => {
    const account = accounts_1.accountsSelectors.getCashAccounts(redux_store_1.default.getState()).first();
    const postedOnDate = luxon_1.DateTime.local().minus({ days: 1 });
    const postedOn = postedOnDate.toISODate();
    const cpId = (0, uuid_1.v4)();
    return {
        inTesting: true,
        accountId: account === null || account === void 0 ? void 0 : account.id,
        pendingAggregationType: 'CURRENT_PENDING_LIST',
        cpData: {
            balance: -56.78,
            balanceAt: luxon_1.DateTime.local().toISO(),
        },
        transactions: [{
                source: 'QCS_REFRESH_BANK_PENDING',
                accountId: account === null || account === void 0 ? void 0 : account.id,
                postedOn,
                payee: 'Safeway Grocceries',
                coa: {
                    type: 'UNCATEGORIZED',
                    id: '0',
                },
                amount: -56.78,
                state: 'PENDING',
                matchState: 'NOT_MATCHED',
                cpData: {
                    id: cpId,
                    cpPendingId: cpId,
                    postedOn,
                    txnOn: postedOn,
                    amount: -56.78,
                    inferredPayee: 'Safeway Grocceries',
                    inferredCoa: {
                        type: 'UNCATEGORIZED',
                        id: '0',
                    },
                    cpCategoryId: '2002',
                },
                type: 'CASH_FLOW',
            }],
    };
};
exports.getPendingTransactionMockData = getPendingTransactionMockData;
const getPostedTransactionMockData = () => {
    const account = accounts_1.accountsSelectors.getCashAccounts(redux_store_1.default.getState()).first();
    const postedOnDate = luxon_1.DateTime.local().minus({ days: 1 });
    const postedOn = postedOnDate.toISODate();
    const cpId = (0, uuid_1.v4)();
    return {
        inTesting: true,
        accountId: account === null || account === void 0 ? void 0 : account.id,
        pendingAggregationType: 'CURRENT_PENDING_LIST',
        cpData: {
            balance: -56.78,
            balanceAt: luxon_1.DateTime.local().toISO(),
        },
        transactions: [{
                source: 'QCS_REFRESH',
                accountId: account === null || account === void 0 ? void 0 : account.id,
                postedOn,
                payee: 'Safeway Grocceries',
                coa: {
                    type: 'UNCATEGORIZED',
                    id: '0',
                },
                amount: -56.78,
                state: 'CLEARED',
                matchState: 'NOT_MATCHED',
                cpData: {
                    id: cpId,
                    cpPendingId: cpId,
                    postedOn,
                    txnOn: postedOn,
                    amount: -56.78,
                    inferredPayee: 'Some Payee',
                    inferredCoa: {
                        type: 'UNCATEGORIZED',
                        id: '0',
                    },
                    cpCategoryId: '2002',
                },
                type: 'CASH_FLOW',
            }, {
                source: 'QCS_REFRESH',
                accountId: account === null || account === void 0 ? void 0 : account.id,
                postedOn,
                payee: 'Safeway Gas',
                coa: {
                    type: 'UNCATEGORIZED',
                    id: '0',
                },
                amount: -12.34,
                state: 'CLEARED',
                matchState: 'NOT_MATCHED',
                cpData: {
                    id: `${cpId}1`,
                    cpPendingId: `${cpId}1`,
                    postedOn,
                    txnOn: postedOn,
                    amount: -12.34,
                    inferredPayee: 'Safeway Gas',
                    inferredCoa: {
                        type: 'UNCATEGORIZED',
                        id: '0',
                    },
                    cpCategoryId: '2002',
                },
                type: 'CASH_FLOW',
            }, {
                source: 'QCS_REFRESH',
                accountId: account === null || account === void 0 ? void 0 : account.id,
                postedOn,
                payee: 'Safeway Refund',
                coa: {
                    type: 'UNCATEGORIZED',
                    id: '0',
                },
                amount: +56.78,
                state: 'CLEARED',
                matchState: 'NOT_MATCHED',
                cpData: {
                    id: `${cpId}2`,
                    cpPendingId: `${cpId}2`,
                    postedOn,
                    txnOn: postedOn,
                    amount: +56.78,
                    inferredPayee: 'Safeway Refund',
                    inferredCoa: {
                        type: 'UNCATEGORIZED',
                        id: '0',
                    },
                    cpCategoryId: '2002',
                },
                type: 'CASH_FLOW',
            }],
    };
};
exports.getPostedTransactionMockData = getPostedTransactionMockData;
